exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plan.current-plan[data-v-d90f4fca]{border:2px solid #f7c44e!important;border-radius:.625rem!important}.btn.current-plan[data-v-d90f4fca]{background:transparent;border:1px solid #000}.btn.current-plan[data-v-d90f4fca]:hover{background:#e2e2e2}", ""]);

// exports
